function closeEventually(resolve) {
	// this should be bound to element of DialogStack
	// eslint-disable-next-line no-invalid-this
	resolve(this); // Returns DialogStack-element back to awaiting function.
	return true;
}

class DialogStack extends Array {
	constructor() {
		if (!DialogStack.instance) {
			super();
			this.remove = this.remove.bind(this);
			this.popNextDialogIfWaiting = this.popNextDialogIfWaiting.bind(this);
			DialogStack.instance = this;
		}
		return DialogStack.instance;
	}

	// Remove dialog with id from stack and return the stack object.
	// If the dialog is not on the top it will wait until it is before popping.
	remove(id) {
		let index = this.map(e => e.id).indexOf(id);
		if (index < 0) return {};
		if (index < this.length - 1) {
			return new Promise(resolve => {
				this[index].closeEventually = closeEventually.bind(this[index], resolve);
			});
		}
		return this.pop();
	}

	// Check if the top dialog is waiting to close, and close it if so.
	popNextDialogIfWaiting() {
		if (!this.length) return;
		if (this[this.length - 1].closeEventually) {
			this[this.length - 1].closeEventually();
			this.pop();
		}
	}
}

const stack = new DialogStack();

// Add shorthand stack.top to get the top object.
Object.defineProperty(stack, 'top', {
	get: function() {
		return this[this.length - 1];
	}.bind(stack)
});

// eslint-disable-next-line
if (process.env.NODE_ENV === 'development') {
	// Let developers inspect the stack when running locally, in case anything weird happens.
	window.__tdialog_stack = stack;
}

export default stack;